var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"product-container"},[_c('Bread',{attrs:{"first-name":"产品中心","metertype":"智慧水务","meter-name":"温湿度采集仪"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }